import BarChart from "../BarChart";
import chartColors from "../chart-colors";
import { getObjectValueByPath } from "vuetify/lib/util/helpers";

export default {
	name: "BarChartMixin",

	computed: {
		averageValue() {
			if ( this.averageObjectValuePath ) {
				const total = this.items.reduce(
					( acc, data ) => acc + getObjectValueByPath( data, this.averageObjectValuePath ),
					0
				);

				return parseFloat( ( total / this.items.length ).toFixed( 1 ) );
			}
		},

		backgroundColors() {
			const availableColors = chartColors.slice( 0, this.barData.length );
			let backgroundColors = [];

			// There may be more bars than defined chart colors
			// So we recycle colors in large data sets
			while ( backgroundColors.length < this.barData.length ) {
				backgroundColors = backgroundColors.concat( availableColors );
			}

			return backgroundColors;
		},

		chartData() {
			return {
				labels: this.labels,
				datasets: [
					{
						backgroundColor: this.backgroundColors,
						data: this.barData
					}
				]
			};
		},

		chartOptions() {
			return {
				title: {
					display: true,
					fontSize: 24,
					text: this.title
				},
				legend: {
					display: false
				},
				maintainAspectRatio: false,
				responsive: true,
				scales: {
					xAxes: [ {
						ticks: {
							autoSkip: false
						}
					} ],

					yAxes: [ {
						scaleLabel: {
							display: true,
							labelString: this.yAxisLabel
						},
						ticks: {
							beginAtZero: true
						}
					} ]
				},
				plugins: {
					datalabels: {
						backgroundColor: "#FFF",
						borderRadius: 5,
						color: "#323232",
						font: {
							weight: 600
						}
					}
				}
			};
		}
	},

	render() {
		return <BarChart
			chartData={this.chartData}
			options={this.chartOptions}
		></BarChart>;
	}
};
